import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaClubDetails';

const AccountJulaClubDetailsSuspense = dynamic(
	() => import('./AccountJulaClubDetails'),
	{
		loading: () => <BlockLoadingSpinner />,
	},
);

export default function DynamicAccountJulaClubDetails(props: Props) {
	return <AccountJulaClubDetailsSuspense {...props} />;
}
DynamicAccountJulaClubDetails.displayName = 'DynamicAccountJulaClubDetails';
